import { Link, useNavigate } from "react-router-dom";

import { Space, Breadcrumb, Card } from "antd";
import { PageHeader } from "@ant-design/pro-layout";

import {
   Site, DeviceData
} from "../../model/model";

import DeviceForm from "./DeviceForm";
import SessionStore from "../../model/SessionStore";

function CreateSiteUser({ site }: { site: Site }) {
  const navigate = useNavigate();

  const onFinish = (obj: DeviceData) => {
    obj.siteId = site.id;

    SessionStore.getClient().createDevice(obj, SessionStore.getBearer()).then( () => {
      navigate(`/site/${site.id}/devices`);
    });
  };

  const tu :DeviceData = {id: "",
    topic: "",
    subId: site.subId,
    orgId: site.orgId,
    siteId: site.id,
    name: "",
    devProfileId: "",
    ioId: "",
    descr: "",
    expires: 0,
    locLat: 0,
    locLong: 0,
    recfreq: 0,
    config: "",
    lastSeenAt: 0,
    online: false,
    gwDevId: "",
    decoderConf: "",
    coils: [],
  };

  return (
    <Space direction="vertical" style={{ width: "100%" }} size="large">
      <PageHeader
        breadcrumbRender={() => (
          <Breadcrumb>
            <Breadcrumb.Item>
              <span>Sites</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span>
                <Link to={`/site/${site.id}/dash`}>{site.name}</Link>
              </span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span>
                <Link to={`/site/${site.id}/users`}>Site devices</Link>
              </span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span>Add</span>
            </Breadcrumb.Item>
          </Breadcrumb>
        )}
        title="Add site device"
      />
      <Card>
        <DeviceForm initialValues={tu} site={site} onFinish={onFinish} />
      </Card>
    </Space>
  );
}

export default CreateSiteUser;
